import Vue from 'vue';
import { commonTransfersHistoryTablesMixin } from '@/components/pages/transfersPage/components/transfersHistory/mixins/index';
import THead from './thead.vue';
import TItem from './titem.vue';
export default Vue.extend({
    components: { THead, TItem },
    name: 'betweenExchangesTable',
    props: {
        items: {
            type: Array,
            required: true
        },
        nextPage: {
            type: Number
        }
    },
    mixins: [
        commonTransfersHistoryTablesMixin
    ],
    data() {
        return {
            scrolledDown: false
        };
    },
    computed: {}
});
